import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import { S, Field } from '../utils/styles';

export default function Vendors() {
  const [vendors, setVendors] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name:'', contact_name:'', phone:'', speciality:'', notes:'' });
  const [saving, setSaving] = useState(false);
  const f = k => v => setForm(p => ({...p, [k]:v}));

  useEffect(() => { load(); }, []);
  const load = () => api.get('/inventory/job-vendors').then(r => setVendors(r.data));

  const openEdit = v => { setEditing(v); setForm({ name:v.name, contact_name:v.contact_name||'', phone:v.phone||'', speciality:v.speciality||'', notes:v.notes||'' }); setShowForm(true); };

  const save = async () => {
    setSaving(true);
    try {
      if (editing) await api.put(`/inventory/job-vendors/${editing.id}`, form);
      else await api.post('/inventory/job-vendors', form);
      load(); setShowForm(false); setEditing(null);
      setForm({ name:'', contact_name:'', phone:'', speciality:'', notes:'' });
    } catch(e) { alert(e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
        <h1 style={{ fontSize:22, fontWeight:600, margin:0 }}>Job Work Vendors</h1>
        <button onClick={() => { setEditing(null); setForm({ name:'', contact_name:'', phone:'', speciality:'', notes:'' }); setShowForm(true); }} style={S.btnPrimary}>+ Add vendor</button>
      </div>
      <div style={{ fontSize:13, color:'#6b7280', marginBottom:16, background:'#eff6ff', padding:'10px 14px', borderRadius:8 }}>
        These are your job work vendors (plating, spot welding, tapping etc.) used in the production stage tracker.
        For detailed batch tracking, use your existing <a href="https://tracker.byldr.in" target="_blank" rel="noreferrer" style={{ color:'#3b82f6' }}>vendor tracking tool</a>.
      </div>

      <div style={{ background:'#fff', borderRadius:10, border:'1px solid #e5e7eb', overflow:'hidden' }}>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead><tr>{['Vendor name','Contact','Phone','Speciality','Notes',''].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
          <tbody>
            {vendors.map(v => (
              <tr key={v.id} style={{ borderBottom:'1px solid #f3f4f6' }}>
                <td style={{ ...S.td, fontWeight:500 }}>{v.name}</td>
                <td style={{ ...S.td, color:'#6b7280' }}>{v.contact_name || '—'}</td>
                <td style={{ ...S.td, color:'#6b7280' }}>{v.phone || '—'}</td>
                <td style={S.td}>{v.speciality || '—'}</td>
                <td style={{ ...S.td, color:'#6b7280', fontSize:12 }}>{v.notes || '—'}</td>
                <td style={S.td}><button onClick={() => openEdit(v)} style={{ ...S.btnSm, background:'#f3f4f6', color:'#374151' }}>Edit</button></td>
              </tr>
            ))}
            {vendors.length === 0 && <tr><td colSpan={6} style={{ textAlign:'center', padding:32, color:'#9ca3af' }}>No vendors yet</td></tr>}
          </tbody>
        </table>
      </div>

      {showForm && (
        <div style={S.overlay}>
          <div style={{ ...S.modal, width:480 }}>
            <div style={{ fontSize:16, fontWeight:600, marginBottom:20 }}>{editing ? 'Edit vendor' : 'Add job work vendor'}</div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:14 }}>
              <Field label="Vendor name" value={form.name} onChange={f('name')} required />
              <Field label="Contact name" value={form.contact_name} onChange={f('contact_name')} />
              <Field label="Phone" value={form.phone} onChange={f('phone')} />
              <Field label="Speciality" value={form.speciality} onChange={f('speciality')} placeholder="e.g. EG plating, spot welding" />
            </div>
            <div style={{ marginBottom:16 }}><label style={S.label}>Notes</label><textarea value={form.notes} onChange={e => f('notes')(e.target.value)} style={{ ...S.input, height:64, resize:'vertical' }} /></div>
            <div style={{ display:'flex', gap:10, paddingTop:16, borderTop:'1px solid #e5e7eb' }}>
              <button onClick={save} disabled={saving||!form.name} style={S.btnPrimary}>{saving ? 'Saving...' : 'Save'}</button>
              <button onClick={() => setShowForm(false)} style={S.btnSecondary}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
